import styled from "@emotion/styled/macro";
import React from "react";

import loadingGif from "./res/img_loading_bob.gif";

const Root = styled("div")`
  background: #4c4d52;
  height: 100%;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Loading = styled("h2")`
  text-align: center;
  font-size: 20px;
  padding-top: 98px;
  background: url(${loadingGif}) no-repeat center top;
  background-size: 90px;
`;

export default function LoadingScreen() {
  return (
    <Root>
      <Loading>Loading...</Loading>
    </Root>
  );
}
